import React, { useState, useEffect } from "react";
import { CircularProgress } from "@material-ui/core";

function ImageLoader({ loaderComponent, ...props }, ref) {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let img = new Image();

        img.onload = () => { setIsLoading(false); };
        img.src = props.src;

        return () => {
            img.onload = null;
            img.onerror = null;
            img = null;
        }
    }, [props.src]);

    if (isLoading) {
        return (
            <div
                ref={ref}
                style={{
                    ...{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }, ...props.style
                }}>
                {loaderComponent ? loaderComponent : <CircularProgress size={20} color={"inherit"} />}
            </div>)
    }

    return (<img ref={ref} {...props} />)
}

export default React.forwardRef(ImageLoader);